import React, { useId } from "react";
import { Box, FormLabel, TextField, TextFieldProps } from "@mui/material";

/** Visible labels above inputs, including select and date inputs. */
export default function EcommField({ label, id, sx, ...props }: TextFieldProps) {
  const generated = useId();
  const fieldId = id || generated;
  return <Box sx={[{ minWidth: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}><FormLabel htmlFor={fieldId} error={props.error} required={props.required} sx={{ display: "block", mb: .75, fontSize: 12, fontWeight: 600, color: "text.secondary" }}>{label}</FormLabel>
    <TextField {...props} id={fieldId} fullWidth size={props.size || "small"} SelectProps={props.select ? { displayEmpty: true, ...props.SelectProps } : props.SelectProps} inputProps={{ ...props.inputProps, "aria-label": typeof label === "string" ? label : props.inputProps?.["aria-label"] }} />
  </Box>;
}
